import { Dispatch, Action } from 'redux'
import { WorkspaceStorageUploadFieldMapDispatchReturnType } from './types/WorkspaceStorageUploadFieldMapDispatchReturnType'

export const WorkspaceStorageUploadFieldMapDispatch = (
  _dispatch: Dispatch<Action>
): WorkspaceStorageUploadFieldMapDispatchReturnType => {
  return {}
}
